module.exports = __webpack_public_path__ + "static/img/app-intro2.55ba5bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app-intro2.svg
// module id = 4n1z
// module chunks = 28